import { render, staticRenderFns } from "./organization-finding-history.vue?vue&type=template&id=9d580724&"
import script from "./organization-finding-history.vue?vue&type=script&lang=js&"
export * from "./organization-finding-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports